"use strict";import{css as e}from"@spectrum-web-components/base";const t=e`
:host{--spectrum-menu-item-min-height:var(--spectrum-component-height-100);--spectrum-menu-item-icon-height:var(--spectrum-workflow-icon-size-100);--spectrum-menu-item-icon-width:var(--spectrum-workflow-icon-size-100);--spectrum-menu-item-label-font-size:var(--spectrum-font-size-100);--spectrum-menu-item-label-text-to-visual:var(
--spectrum-text-to-visual-100
);--spectrum-menu-item-label-inline-edge-to-content:var(
--spectrum-component-edge-to-text-100
);--spectrum-menu-item-top-edge-to-text:var(
--spectrum-component-top-to-text-100
);--spectrum-menu-item-bottom-edge-to-text:var(
--spectrum-component-bottom-to-text-100
);--spectrum-menu-item-text-to-control:var(--spectrum-text-to-control-100);--spectrum-menu-item-description-font-size:var(--spectrum-font-size-75);--spectrum-menu-section-header-font-size:var(--spectrum-font-size-100);--spectrum-menu-section-header-min-width:var(
--spectrum-component-height-100
);--spectrum-menu-item-selectable-edge-to-text-not-selected:var(
--spectrum-menu-item-selectable-edge-to-text-not-selected-medium
);--spectrum-menu-item-checkmark-height:var(
--spectrum-menu-item-checkmark-height-medium
);--spectrum-menu-item-checkmark-width:var(
--spectrum-menu-item-checkmark-width-medium
);--spectrum-menu-item-top-to-checkmark:var(
--spectrum-menu-item-top-to-selected-icon-medium
);--spectrum-menu-item-label-line-height:var(--spectrum-line-height-100);--spectrum-menu-item-label-line-height-cjk:var(
--spectrum-cjk-line-height-100
);--spectrum-menu-item-label-to-description-spacing:var(
--spectrum-menu-item-label-to-description
);--spectrum-menu-item-focus-indicator-width:var(
--spectrum-border-width-200
);--spectrum-menu-item-focus-indicator-color:var(--spectrum-blue-800);--spectrum-menu-item-label-to-value-area-min-spacing:var(
--spectrum-spacing-100
);--spectrum-menu-item-label-content-color-default:var(
--spectrum-neutral-content-color-default
);--spectrum-menu-item-label-content-color-hover:var(
--spectrum-neutral-content-color-hover
);--spectrum-menu-item-label-content-color-down:var(
--spectrum-neutral-content-color-down
);--spectrum-menu-item-label-content-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--spectrum-menu-item-label-icon-color-default:var(
--spectrum-neutral-content-color-default
);--spectrum-menu-item-label-icon-color-hover:var(
--spectrum-neutral-content-color-hover
);--spectrum-menu-item-label-icon-color-down:var(
--spectrum-neutral-content-color-down
);--spectrum-menu-item-label-icon-color-focus:var(
--spectrum-neutral-content-color-key-focus
);--spectrum-menu-item-label-content-color-disabled:var(
--spectrum-disabled-content-color
);--spectrum-menu-item-label-icon-color-disabled:var(
--spectrum-disabled-content-color
);--spectrum-menu-item-description-line-height:var(
--spectrum-line-height-100
);--spectrum-menu-item-description-line-height-cjk:var(
--spectrum-cjk-line-height-100
);--spectrum-menu-item-description-color-default:var(
--spectrum-neutral-subdued-content-color-default
);--spectrum-menu-item-description-color-hover:var(
--spectrum-neutral-subdued-content-color-hover
);--spectrum-menu-item-description-color-down:var(
--spectrum-neutral-subdued-content-color-down
);--spectrum-menu-item-description-color-focus:var(
--spectrum-neutral-subdued-content-color-key-focus
);--spectrum-menu-item-description-color-disabled:var(
--spectrum-disabled-content-color
);--spectrum-menu-section-header-line-height:var(--spectrum-line-height-100);--spectrum-menu-section-header-line-height-cjk:var(
--spectrum-cjk-line-height-100
);--spectrum-menu-section-header-font-weight:var(
--spectrum-bold-font-weight
);--spectrum-menu-section-header-color:var(--spectrum-gray-900);--spectrum-menu-collapsible-icon-color:var(--spectrum-gray-900);--spectrum-menu-checkmark-icon-color-default:var(
--spectrum-accent-color-900
);--spectrum-menu-checkmark-icon-color-hover:var(
--spectrum-accent-color-1000
);--spectrum-menu-checkmark-icon-color-down:var(
--spectrum-accent-color-1100
);--spectrum-menu-checkmark-icon-color-focus:var(
--spectrum-accent-color-1000
);--spectrum-menu-drillin-icon-color-default:var(
--spectrum-neutral-subdued-content-color-default
);--spectrum-menu-drillin-icon-color-hover:var(
--spectrum-neutral-subdued-content-color-hover
);--spectrum-menu-drillin-icon-color-down:var(
--spectrum-neutral-subdued-content-color-down
);--spectrum-menu-drillin-icon-color-focus:var(
--spectrum-neutral-subdued-content-color-key-focus
);--spectrum-menu-item-value-color-default:var(
--spectrum-neutral-subdued-content-color-default
);--spectrum-menu-item-value-color-hover:var(
--spectrum-neutral-subdued-content-color-hover
);--spectrum-menu-item-value-color-down:var(
--spectrum-neutral-subdued-content-color-down
);--spectrum-menu-item-value-color-focus:var(
--spectrum-neutral-subdued-content-color-key-focus
);--spectrum-menu-checkmark-display-hidden:none;--spectrum-menu-checkmark-display-shown:block;--spectrum-menu-checkmark-display:var(
--spectrum-menu-checkmark-display-shown
);--spectrum-menu-item-collapsible-has-icon-submenu-item-padding-x-start:calc(var(--spectrum-menu-item-label-inline-edge-to-content) + var(--spectrum-menu-item-checkmark-width) + var(--spectrum-menu-item-text-to-control) + var(--spectrum-menu-item-icon-width) + var(--spectrum-menu-item-label-text-to-visual) + var(--spectrum-menu-item-focus-indicator-width));--spectrum-menu-item-collapsible-no-icon-submenu-item-padding-x-start:calc(var(--spectrum-menu-item-label-inline-edge-to-content) + var(--spectrum-menu-item-checkmark-width) + var(--spectrum-menu-item-label-text-to-visual) + var(--spectrum-menu-item-focus-indicator-width))}:host([size=s]){--spectrum-menu-item-min-height:var(--spectrum-component-height-75);--spectrum-menu-item-icon-height:var(--spectrum-workflow-icon-size-75);--spectrum-menu-item-icon-width:var(--spectrum-workflow-icon-size-75);--spectrum-menu-item-label-font-size:var(--spectrum-font-size-75);--spectrum-menu-item-label-text-to-visual:var(
--spectrum-text-to-visual-75
);--spectrum-menu-item-label-inline-edge-to-content:var(
--spectrum-component-edge-to-text-75
);--spectrum-menu-item-top-edge-to-text:var(
--spectrum-component-top-to-text-75
);--spectrum-menu-item-bottom-edge-to-text:var(
--spectrum-component-bottom-to-text-75
);--spectrum-menu-item-text-to-control:var(--spectrum-text-to-control-75);--spectrum-menu-item-description-font-size:var(--spectrum-font-size-50);--spectrum-menu-section-header-font-size:var(--spectrum-font-size-75);--spectrum-menu-section-header-min-width:var(
--spectrum-component-height-75
);--spectrum-menu-item-selectable-edge-to-text-not-selected:var(
--spectrum-menu-item-selectable-edge-to-text-not-selected-small
);--spectrum-menu-item-checkmark-height:var(
--spectrum-menu-item-checkmark-height-small
);--spectrum-menu-item-checkmark-width:var(
--spectrum-menu-item-checkmark-width-small
);--spectrum-menu-item-top-to-checkmark:var(
--spectrum-menu-item-top-to-selected-icon-small
)}:host([size=l]){--spectrum-menu-item-min-height:var(--spectrum-component-height-200);--spectrum-menu-item-icon-height:var(--spectrum-workflow-icon-size-200);--spectrum-menu-item-icon-width:var(--spectrum-workflow-icon-size-200);--spectrum-menu-item-label-font-size:var(--spectrum-font-size-200);--spectrum-menu-item-label-text-to-visual:var(
--spectrum-text-to-visual-200
);--spectrum-menu-item-label-inline-edge-to-content:var(
--spectrum-component-edge-to-text-200
);--spectrum-menu-item-top-edge-to-text:var(
--spectrum-component-top-to-text-200
);--spectrum-menu-item-bottom-edge-to-text:var(
--spectrum-component-bottom-to-text-200
);--spectrum-menu-item-text-to-control:var(--spectrum-text-to-control-200);--spectrum-menu-item-description-font-size:var(--spectrum-font-size-100);--spectrum-menu-section-header-font-size:var(--spectrum-font-size-200);--spectrum-menu-section-header-min-width:var(
--spectrum-component-height-200
);--spectrum-menu-item-selectable-edge-to-text-not-selected:var(
--spectrum-menu-item-selectable-edge-to-text-not-selected-large
);--spectrum-menu-item-checkmark-height:var(
--spectrum-menu-item-checkmark-height-large
);--spectrum-menu-item-checkmark-width:var(
--spectrum-menu-item-checkmark-width-large
);--spectrum-menu-item-top-to-checkmark:var(
--spectrum-menu-item-top-to-selected-icon-large
)}:host([size=xl]){--spectrum-menu-item-min-height:var(--spectrum-component-height-300);--spectrum-menu-item-icon-height:var(--spectrum-workflow-icon-size-300);--spectrum-menu-item-icon-width:var(--spectrum-workflow-icon-size-300);--spectrum-menu-item-label-font-size:var(--spectrum-font-size-300);--spectrum-menu-item-label-text-to-visual:var(
--spectrum-text-to-visual-300
);--spectrum-menu-item-label-inline-edge-to-content:var(
--spectrum-component-edge-to-text-300
);--spectrum-menu-item-top-edge-to-text:var(
--spectrum-component-top-to-text-300
);--spectrum-menu-item-bottom-edge-to-text:var(
--spectrum-component-bottom-to-text-300
);--spectrum-menu-item-text-to-control:var(--spectrum-text-to-control-300);--spectrum-menu-item-description-font-size:var(--spectrum-font-size-200);--spectrum-menu-section-header-font-size:var(--spectrum-font-size-300);--spectrum-menu-section-header-min-width:var(
--spectrum-component-height-300
);--spectrum-menu-item-selectable-edge-to-text-not-selected:var(
--spectrum-menu-item-selectable-edge-to-text-not-selected-extra-large
);--spectrum-menu-item-checkmark-height:var(
--spectrum-menu-item-checkmark-height-extra-large
);--spectrum-menu-item-checkmark-width:var(
--spectrum-menu-item-checkmark-width-extra-large
);--spectrum-menu-item-top-to-checkmark:var(
--spectrum-menu-item-top-to-selected-icon-extra-large
)}@media (forced-colors:active){:host{--highcontrast-menu-item-background-color-default:ButtonFace;--highcontrast-menu-item-color-default:ButtonText;--highcontrast-menu-item-background-color-focus:Highlight;--highcontrast-menu-item-color-focus:HighlightText;--highcontrast-menu-checkmark-icon-color-default:Highlight;--highcontrast-menu-item-color-disabled:GrayText;--highcontrast-menu-item-focus-indicator-color:Highlight;--highcontrast-menu-item-selected-background-color:Highlight;--highcontrast-menu-item-selected-color:HighlightText}@supports (color:SelectedItem){:host{--highcontrast-menu-item-selected-background-color:SelectedItem;--highcontrast-menu-item-selected-color:SelectedItemText}}}:host{box-sizing:border-box;display:inline-block;list-style-type:none;margin:0;overflow:auto;padding:0}:host:lang(ja),:host:lang(ko),:host:lang(zh){--spectrum-menu-item-label-line-height:var(
--mod-menu-item-label-line-height-cjk,var(--spectrum-menu-item-label-line-height-cjk)
);--spectrum-menu-item-description-line-height:var(
--mod-menu-item-description-line-height-cjk,var(--spectrum-menu-item-description-line-height-cjk)
);--spectrum-menu-section-header-line-height:var(
--mod-menu-section-header-line-height-cjk,var(--spectrum-menu-section-header-line-height-cjk)
)}:host([selects]) ::slotted(sp-menu-item){--spectrum-menu-checkmark-display:var(
--spectrum-menu-checkmark-display-hidden
);padding-inline-start:var(
--mod-menu-item-selectable-edge-to-text-not-selected,var(--spectrum-menu-item-selectable-edge-to-text-not-selected)
)}:host([selects]) ::slotted(sp-menu-item[selected]){--spectrum-menu-checkmark-display:var(
--spectrum-menu-checkmark-display-shown
);padding-inline-start:var(
--mod-menu-item-label-inline-edge-to-content,var(--spectrum-menu-item-label-inline-edge-to-content)
)}li:not(::slotted(sp-menu-item),.menu-divider){box-sizing:border-box;display:block;margin:0;padding:0;position:relative}.spectrum-Menu-sectionHeading{color:var(
--highcontrast-menu-item-color-default,var(
--mod-menu-section-header-color,var(--spectrum-menu-section-header-color)
)
);display:block;font-size:var(
--mod-menu-section-header-font-size,var(--spectrum-menu-section-header-font-size)
);font-weight:var(
--mod-menu-section-header-font-weight,var(--spectrum-menu-section-header-font-weight)
);grid-area:sectionHeadingArea/1/sectionHeadingArea/-1;line-height:var(
--mod-menu-section-header-line-height,var(--spectrum-menu-section-header-line-height)
);min-inline-size:var(
--mod-menu-section-header-min-width,var(--spectrum-menu-section-header-min-width)
);padding-block-end:var(
--mod-menu-section-header-bottom-edge-to-text,var(
--mod-menu-item-bottom-edge-to-text,var(--spectrum-menu-item-bottom-edge-to-text)
)
);padding-block-start:var(
--mod-menu-section-header-top-edge-to-text,var(
--mod-menu-item-top-edge-to-text,var(--spectrum-menu-item-top-edge-to-text)
)
);padding-inline:var(
--mod-menu-item-label-inline-edge-to-content,var(--spectrum-menu-item-label-inline-edge-to-content)
)}:host{display:inline-flex;flex-direction:column;width:var(--swc-menu-width)}:host(:focus){outline:none}::slotted(*){flex-shrink:0}
`;export default t;
//# sourceMappingURL=menu.css.js.map
